import { useContext } from 'react'
import { QuantityContext, type IQuantityContext } from './QuantityContext'

const useQuantity = (): IQuantityContext => {
  return useContext(QuantityContext)
}

export default useQuantity
